// extracted by mini-css-extract-plugin
module.exports = {"base":"Card_base__3g7A5","primary":"Card_primary__1cbJy","uhc":"Card_uhc__28VeW"};